__turbopack_context__.v({
  "icon": "SetPfpButton-module__Y8Uzdq__icon",
  "root": "SetPfpButton-module__Y8Uzdq__root",
});
